export default __webpack_public_path__ + "static/media/current_lab.99e22d93.svg";